import classNames from 'classnames'
import {Field} from 'formik'
import {useEffect} from 'react'
import {useSelector} from 'react-redux'
import Checkbox from '../../../components/core/checkbox'
import CustomSelect from '../../../components/core/customSelect'
import Error from '../../../components/core/error'
import Tooltip from '../../../components/core/tooltip'
import {NewInfoIcon} from '../../../icons'
import renderSkeletonLoaders from '../../../utils/loader'

const SELECT = 'select'
const CHECKBOX = 'checkbox'
const TIMEZONE = 'timezone'

const DynamicForm = ({formValues, setFieldValue, errors, setIsNextButtonActive, isStepCompleted, monitoringTypeData, setInitialFormValues, isLoading = false, defaultFormValues, disabled}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    useEffect(() => {
        setIsNextButtonActive && isStepCompleted && setIsNextButtonActive(isStepCompleted())
        setInitialFormValues && setInitialFormValues(formValues)
    }, [formValues])

    const handleChangeSelectValue = (name, value, setFieldValue) => {
        const selectedOptions = defaultFormValues.find(formValue => formValue.name === name).options
        setFieldValue(name, {...value, options: selectedOptions})
    }

    return (
        <form>
            {monitoringTypeData?.map((item, index) => (
                <div key={index} className = {classNames(`form-type-component ${item.type}`, {
                    dark: isDarkMode
                })}>
                    {isLoading ? <span className={classNames('field-container', {
                        dark: isDarkMode
                    })}>{renderSkeletonLoaders(1, `${item?.type}-skeleton`)}
                    </span> : item.type === SELECT ?
                        <CustomSelect
                            name={item.name}
                            value={formValues?.[item.name]}
                            onChange={(name, value) => handleChangeSelectValue(name, value, setFieldValue)}
                            error={errors?.[item.name]}
                            menuPosition="fixed"
                            isSearchable={item.name === TIMEZONE}
                            isClearable={item.name === TIMEZONE}
                            placeholder={item.placeholder}
                            options={formValues?.[item.name]?.options}
                            isDisabled={disabled}
                        /> : item.type === CHECKBOX ?
                            <Checkbox
                                type={item.type}
                                checked={formValues?.[item.name]}
                                label={item.placeholder}
                                onChange={(e) => setFieldValue(item.name, e.target.checked)}
                                disabled={disabled}
                            /> :
                            <div className={classNames('field-container', {
                                dark: isDarkMode
                            })}>
                                <Field
                                    key={index}
                                    as={`${item.type}`}
                                    name={item.name}
                                    value={formValues?.[item.name] || ''}
                                    onChange={(e) => setFieldValue(item.name, e.target.value)}
                                    className={`form-control ${formValues?.[item.name] ? 'has-value' : ''}`}
                                    disabled={disabled}
                                />
                                <span className="input-placeholder">{item.placeholder}</span>
                                {errors?.[item.name] && <Error error={errors?.[item.name]}/>}
                            </div>}
                    {!isLoading && <Tooltip placement="left" trigger="click" content={item.info_text} className={item.type === SELECT ? 'select-tooltip' : ''}>
                        <NewInfoIcon />
                    </Tooltip>}
                </div>
            ))}
        </form>
    )
}

export default DynamicForm

